import loginReducer from './login.reducer'

export {default as loginActions} from './login.actions'
export {types as loginTypes} from './login.actions'
export {default as loginSelectors} from './login.selectors'


export default loginReducer;

